<template>
  <nav class="hc-schedule-tabs" aria-label="Menu Jadwal Dokter">
    <router-link
      v-if="showSchedules"
      to="/schedule/list"
      class="hc-schedule-tabs__item"
      active-class="hc-schedule-tabs__item--active"
    >
      <i class="far fa-calendar-alt" aria-hidden="true"></i>
      <span>Semua Jadwal</span>
    </router-link>
    <router-link
      v-if="showHolidays"
      to="/schedule/holidays"
      class="hc-schedule-tabs__item"
      active-class="hc-schedule-tabs__item--active"
    >
      <i class="far fa-calendar-times" aria-hidden="true"></i>
      <span>Hari Libur</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'ScheduleTabs',

  data() {
    const rawAccessRights = window.localStorage.getItem('access_right_display')
    let accessRights = []

    try {
      accessRights = (JSON.parse(rawAccessRights) || []).map(String)
    } catch (error) {
      accessRights = []
    }

    return {
      accessRights,
    }
  },

  computed: {
    showSchedules() {
      return this.accessRights.length === 0 || this.accessRights.includes('4001')
    },

    showHolidays() {
      return this.accessRights.length === 0 || this.accessRights.includes('4001')
    },
  },
}
</script>

<style lang="scss" scoped>
.hc-schedule-tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  margin: 0 0 16px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f1f5f9;
}

.hc-schedule-tabs__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 16px;
  border-radius: 9px;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: var(--skin-primary);
    text-decoration: none;
  }

  &--active {
    color: var(--skin-primary);
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(var(--skin-deep-rgb), 0.1);
  }
}

@media (max-width: 575.98px) {
  .hc-schedule-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .hc-schedule-tabs__item {
    padding: 0 10px;
  }
}
</style>
